import {createApp} from "vue";
import ActivitySearchHeader from "./ActivitySearchHeader.vue";
import {createPinia} from "pinia";

const pinia = createPinia();

const app = createApp(ActivitySearchHeader);

app.use(pinia);
app.mount("#activity-search-header");